var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-scc-portal",attrs:{"id":""}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(" Payment Successful ")]),_c('p',[_vm._v("We have got your order!")]),_c('p',[_vm._v("E-Mail Sent Successfully to "+_vm._s(_vm.recipientEmail))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }